import React from "react"
import playiconsvg from "../assets/playiconsvg.svg"
import { motion } from "framer-motion"
import { journeys } from "../constants"
import { fadeIn } from "../utils/motion"
import { Link } from "react-router-dom"
const JourneyCard = ({ index, description, image }) => {
  return (
    <motion.div
      initial="hidden"
      whileInView="show"
      viewport={{ once: true }}
      variants={fadeIn("left", "spring", index * 0.5, 0.75)}
    >
      <div className="py-5 rounded-2xl sm:w-[330px] w-full">
        <div className="relative w-full h-[278px]">
          <img
            src={image}
            alt="project_image"
            className="w-full h-full object-cover rounded-xl"
          />
        </div>

        <div className="mt-5">
          <p className="mt-2 text-neutral-300 text-[14px]">{description}</p>
        </div>
      </div>
    </motion.div>
  )
}
const Journey = ({ index }) => {
  return (
    <>
      <div className=" journey-container mt-20 px-[15px] md:px-[40px] lg:px-[60px] xl:px-[80px] 2xl:px-[100px] w-full">
        <div className="pt-12 px-0 md:px-7">
          <motion.h2
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            variants={fadeIn("up", "spring", 0.3, 0.4)}
            className="text-4xl lg:text-5xl leading-tight md:leading-normal font-semibold text-left"
          >
            <span className="tracking-wide ">The Blueprint of a Legacy</span>
          </motion.h2>
          <motion.p
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            variants={fadeIn("down", "spring", 0.5, 0.6)}
            className="tracking-xwide quote-title text-sm flex items-center mt-8   uppercase"
          >
            Watch the journey
            <span className="ml-3 w-8">
              {" "}
              <Link to="/journeypage">
                <img src={playiconsvg} alt="double down arrow svg" />
              </Link>
            </span>
          </motion.p>
          {/* <motion.p
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            variants={fadeIn("right", "tween", 0.5, 0.75)}
            className="mt-6 text-left text-neutral-300"
          >
            {" "}
            Some information about history of company
          </motion.p> */}
        </div>
        <div className="mt-10 flex flex-wrap gap-5 justify-center overflow-hidden ">
          {journeys.slice(0, 3).map((journey, index) => (
            <JourneyCard key={` journey-${index}`} index={index} {...journey} />
          ))}
        </div>
      </div>
      <motion.div
        initial="hidden"
        whileInView="show"
        viewport={{ once: true }}
        variants={fadeIn("up", "spring", 0.5, 0.6)}
        className="gold w-3/5 h-[1px] mt-20 lg:mt-30 ml-auto mr-0 overflow-hidden"
      ></motion.div>
    </>
  )
}

export default Journey
